import { motion } from 'framer-motion';
import styled from 'styled-components';

export const StyledLoopTopLeftLogoContainer = styled(motion.div)`
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    display: flex;
    padding: 24px 18px 14px 30px;
    width: 108px;
    height: 35px;
    background-color: ${(p) => p.theme.colors.white};
    border-bottom-right-radius: 28px;
`;

export const StyledLoopTopLeftEdgeContainer = styled.div`
    width: 0%;
    height: 0%;
    display: flex;

    &::after,
    &::before {
        content: 'a';
        color: transparent;
        position: absolute;
        width: 28px;
        height: 28px;
    }

    &::before {
        height: 38px;
        top: 0;
        left: 100%;
        background: radial-gradient(circle 20px at 28px 38px, rgba(255,255,255,0) 28px, #ffffff 100%);
    }
    &::after {
        width: 38px;
        top: 100%;
        left: 0;
        background: radial-gradient(circle 20px at 38px 28px, rgba(255,255,255,0) 28px, #ffffff 100%);
    }
`;

export const StyledLoopTopLeftLogo = styled(motion.img)<{$clickable?: boolean}>`
    width: 100%;
    cursor: ${(p) => (p.$clickable ? 'pointer' : 'default')};
`;
